<template>
  <div
    class="home_container"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="head_container" :class="{ 'top-reached': isTopReached }">
      <!-- 订单处理提示 -->
      <div class="order_tip flex-rowl" v-if="isOrder && !isTopReached">
        <div class="icon flex-rowl">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('@/assets/images/message_icon.png')"
          ></el-image>
        </div>
        <p>
          有未完成支付的订单等待处理。<span
            @click="handleGo2('cRetailOrderList')"
            >[ 点击查看详情... ]</span
          >
        </p>
      </div>
      <!-- 搜索、搜索栏目 -->
      <div class="search_container flex-between">
        <div class="sraech_sort flex-rowl">
          <div class="rest_box flex-rowl" @click="handleRest">
            Reset <span class="rest_icon"></span>
          </div>
          <div class="ordertype_box flex-rowl">
            Sales Popularity
            <span class="shangzhang_icon" @click="handleOrderType(2)"></span>
            <span class="xiajiang_icon" @click="handleOrderType(3)"></span>
          </div>
        </div>
        <div class="search flex-rowl">
          <div class="txt">Search</div>
          <div class="search_input_box flex-rowl">
            <el-input
              v-model="params.keyword"
              placeholder="Enter Keywords"
              class="search_input"
            ></el-input>
            <span @click="handleSearch"></span>
          </div>
        </div>
      </div>
      <!-- 栏目 start -->
      <div class="shop_category_wrap" v-if="!isTopReached">
        <swiper :options="swiperOption1" ref="mySwiper">
          <swiper-slide v-for="(item, index) in commodityList" :key="index">
            <div class="shop_category_main flex-rowl">
              <div class="thumb">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="'https://shop.winksshowp.com/Upload/' + item.img"
                  fit="cover"
                ></el-image>
              </div>
              <div class="content">
                <h1>{{ item.mul_labelname }}</h1>
                <p>{{ item.mul_labelcont }}</p>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev commodity_wrap_swiper-prev">
          <i class="iconfont icon-right"></i>
        </div>
        <div class="swiper-button-next commodity_wrap_swiper-next">
          <i class="iconfont icon-right"></i>
        </div>
      </div>
      <!-- 栏目 end -->
      <!-- 商品标签 start -->
      <div class="label_container flex-rowl">
        <div class="icon"></div>
        <div
          class="label_wrap flex-rowl"
          v-for="(item, index) in labelList"
          :key="index"
        >
          <div class="label_item" @click="handleLabel(item)">
            {{ item.mul_typename }}
          </div>
        </div>
      </div>
      <!-- 商品标签 end -->
    </div>

    <!-- 商品列表 start -->
    <div class="commodity_container">
      <div
        class="commodity_wrap"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="commodity_list flex-rowl">
          <div
            class="commodity_list_item"
            v-for="(itemChild, indexChild) in item"
            :key="indexChild"
          >
            <div class="thumb">
              <el-image
                style="width: 100%; height: 100%"
                :src="itemChild.banner"
                fit="cover"
              ></el-image>
              <div class="label_group flex-colc">
                <p
                  v-for="(itemLabel, indexLabel) in itemChild.labelsstr"
                  :key="indexLabel"
                >
                  # {{ itemLabel.mul_labelcont }}
                </p>
              </div>
            </div>
            <div class="content">
              <div class="tit">{{ itemChild.mul_commodityname }}</div>
              <div class="brand flex-rowl">
                <span class="iconfont icon-peihuo"></span>
                {{
                  itemChild.qyename ? itemChild.qyename : itemChild.qy_accountid
                }}
              </div>
              <div class="txt">400+ bought Past 30 days</div>
              <div class="grade flex-rowl">
                <p>Buyers' Evaluate：</p>
                <div class="leval_group flex-rowl">
                  <span
                    v-for="(itemScore, indexScore) in 5"
                    :key="indexScore"
                    class="iconfont icon-pingfen1"
                    :class="{
                      active: indexScore < item.countryScore,
                      ['score_' + itemScore]: true,
                    }"
                  ></span>

                  <!-- <span class="iconfont icon-pingfen1 active"></span>
                    <span class="iconfont icon-pingfen1 active"></span>
                    <span class="iconfont icon-pingfen1"></span>
                    <span class="iconfont icon-pingfen1"></span> -->
                </div>
              </div>
              <div class="price flex-rowl">
                <div class="symbol flex-colc">
                  <span>Reference</span>
                  <span class="unit">({{ COUNTRY.moneyslog }}） : </span>
                </div>
                <!-- 20.<span>7</span> -->
                <div class="num" v-html="itemChild.mulstr_price"></div>
              </div>
              <div class="label flex-rowl">
                <p>Retail</p>
                <p>Batch</p>
                <p>Big Orders</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商品列表 end -->

    <!-- 左侧固定内容 start -->
    <div class="left-fixed" :class="{ 'slide-in': isTopReached }">
      <!-- 商品分类 -->
      <div
        class="shop-category-wrap"
        :class="{ 'new-shop-category-style': shouldAddShopCategoryClass }"
      >
        <div class="shop-category-content">
          <!-- 展开 -->
          <div
            class="shop-category-content-show flex-colc"
            v-if="shopCategoryExpanded"
            ref="swiperContainer"
            :style="{ display: swiperVisible ? 'block' : 'none' }"
          >
            <div class="shop_category_wrap">
              <swiper :options="swiperOption1" ref="mySwiperFixed">
                <swiper-slide
                  v-for="(item, index) in commodityList"
                  :key="index"
                >
                  <div class="shop_category_main flex-rowl">
                    <div class="thumb">
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="'https://shop.winksshowp.com/Upload/' + item.img"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="content">
                      <h1>{{ item.mul_labelname }}</h1>
                      <p>{{ item.mul_labelcont }}</p>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-button-prev commodity_wrap_swiper-prev">
                <i class="iconfont icon-right"></i>
              </div>
              <div class="swiper-button-next commodity_wrap_swiper-next">
                <i class="iconfont icon-right"></i>
              </div>
            </div>
          </div>
          <!-- 收缩 -->
          <div class="shop-category-content-hide flex-rowc" v-else>
            <div class="icon"></div>
          </div>
        </div>

        <!-- 切换按钮 -->
        <div
          class="toggle-btn flex-rowc"
          :class="{ 'new-toggle-btn': shouldAddShopCategoryClass }"
          @click="toggleShopCategory"
        >
          <span></span>
        </div>
      </div>

      <!-- 订单处理提示 -->
      <div
        v-if="isOrder"
        class="order-tip-wrap"
        :class="{ 'new-order-tip-style': shouldAddOrderTipClass }"
      >
        <div class="order-tip-content">
          <!-- 展开 -->
          <div class="order-tip-content-show flex-colc" v-if="orderTipExpanded">
            <div class="txt">
              有未完成支付的订单 <br />
              等待处理。
            </div>
            <div class="more" @click="handleGo2('cRetailOrderList')">
              [ 点击查看详情... ]
            </div>
          </div>
          <!-- 收缩 -->
          <div class="order-tip-content-hide flex-rowc" v-else>
            <div class="icon"></div>
            <span class="mark"></span>
          </div>
        </div>
        <!-- 切换按钮 -->
        <div
          class="toggle-btn flex-rowc"
          :class="{ 'new-toggle-btn': shouldAddOrderTipClass }"
          @click="toggleOrderTip"
        >
          <span></span>
        </div>
      </div>
    </div>
    <!-- 左侧固定内容 end -->
  </div>
</template>
  
  <script>
// 引入文件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import {
  encryptstringadd,
  getCommonditySpecial,
  getSpecialQyList,
  getCommondityLabel,
  getShopKeywordLabel,
} from "../api/api";
import {
  editShopMultiPrice,
  addShopMultiPrice,
  getOrderListWeb,
} from "../api/shop";
import {
  getSpecialUserResourceList,
  getLogisticsAddressList,
} from "../api/managCenter";
import { calculator } from "../utils/decimal";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "homeDetail",
  //import引入的组件需要注入到对象中才能使用
  components: { swiper, swiperSlide },
  data() {
    return {
      loading: false,
      dataList: [],
      params: {
        Page: "1",
        PageSize: 30,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: "",
        countryid: "", // 根据国家屏蔽特定的企业 countryid从接口549获取
        fav_openid: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
      },
      label1Str: "",
      label2Str: "",
      label3Str: "",
      qyStr: "",
      listTotal: 0,
      value1: "",
      orderTotal: [],
      OrderMoney: [],
      brandList: [], // 品牌列表

      isLabelShow: false,
      label1Arr: [], // 一级标签列表
      label2Arr: [], // 二级标签列表
      label3Arr: [], // 三级标签列表

      isShow: false,
      qyList: [],

      isKeywordLabelShow: false, // 关键字弹窗
      popupLabelList: [], // 关键字标签
      labelList: [], // 关键字标签
      labelCheck: [],

      // 多币种价格
      multilingualPrice: "",

      // 是否触发订单按钮
      triggerOrder: {
        isClick: false,
        qyid: "",
        id: "",
      },
      // 是否设置价格-复制价格
      issetCopyPrice: false,

      // 是否有未完成的订单
      isOrder: false,

      // 是否显示用户完善信息提示
      isUserInfoShow: false,
      // 存在物流信息
      isLogistics: false,
      // 存在仓库信息
      isWarehouse: false,

      swiperOption1: {
        slidesPerView: 5,
        autoplay: {
          //自动开始
          delay: 2000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        loop: false,
        initialSlide: 0, //初始化页码
        prevButton: ".commodity_wrap_swiper-prev",
        nextButton: ".commodity_wrap_swiper-next",
      },
      // 商品分类
      commodityList: [],
      isTopReached: false, // 是否固定元素

      orderTipExpanded: false, // 订单提示展开状态
      shopCategoryExpanded: false, // 商品分类展开状态
      shouldAddOrderTipClass: false, // 控制订单提示是否添加新类的标志
      shouldAddShopCategoryClass: false, // 控制商品分类是否添加新类的标志
      swiperVisible: false, // swiper 是否可见
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "dataPage", "COUNTRY", "USERINFO", "COUNTRYLIST"]),
  },

  created() {
    let { COUNTRY } = this.$store.state;
    this.params.countryid = COUNTRY.countryid ? parseInt(COUNTRY.countryid) : 1;

    this.params.Page = this.dataPage;
    this.params.fav_openid = this.OPENID;
    // 获取参数id
    this.params.labelid = this.$route.query.id;

    this.getCommondityLabel(); // 获取商品分类
    this.initData(); // 获取商品列表

    this.getShopKeywordLabel();
    // this.getSpecialQyList();

    this.getOrderListWeb();

    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleMultilingualName(type, dataList, key1, key2) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        // 根据不同国家countryid获取评分
        if (v.ams_shop_commodity_area && v.ams_shop_commodity_area.length > 0) {
          v.ams_shop_commodity_area.forEach((v1) => {
            if (v1.countryid == countryid) {
              v.countryScore = v1.average;
            }
          });
        }

        if (countryid == 1) {
          v[`mul_${key1}`] = v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelsstr 数组
            if (v.labelsstr && Array.isArray(v.labelsstr)) {
              v.labelsstr = v.labelsstr.map((label) => {
                label.mul_labelcont = label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.price;
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }
        } else if (countryid == 8) {
          // 英文
          v[`mul_${key1}`] = v[key1 + "_e"] ? v[key1 + "_e"] : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_e"] ? v[key2 + "_e"] : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelsstr 数组
            if (v.labelsstr && Array.isArray(v.labelsstr)) {
              v.labelsstr = v.labelsstr.map((label) => {
                label.mul_labelcont = label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.ame_price
              ? v.ams_shop_commodity_exrate.ame_price
              : "";
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }
        } else if (countryid == 2) {
          // 俄语
          v[`mul_${key1}`] = v[key1 + "_m"]
            ? v[key1 + "_m"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_m"]
              ? v[key2 + "_m"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelsstr 数组
            if (v.labelsstr && Array.isArray(v.labelsstr)) {
              v.labelsstr = v.labelsstr.map((label) => {
                label.mul_labelcont = label.labelcont_m
                  ? label.labelcont_m
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.lu_price
              ? v.ams_shop_commodity_exrate.lu_price
              : "";
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }
        } else if (countryid == 4) {
          // 越语
          v[`mul_${key1}`] = v[key1 + "_y"]
            ? v[key1 + "_y"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_y"]
              ? v[key2 + "_y"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelsstr 数组
            if (v.labelsstr && Array.isArray(v.labelsstr)) {
              v.labelsstr = v.labelsstr.map((label) => {
                label.mul_labelcont = label.labelcont_y
                  ? label.labelcont_y
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.yue_price
              ? v.ams_shop_commodity_exrate.yue_price
              : "";
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }
        }
      });
      return dataList;

      // 定义处理价格格式的函数
      function formatPrice(price) {
        const priceStr = String(price);
        const parts = priceStr.split(".");
        if (parts.length > 1) {
          return `${parts[0]}.<span>${parts[1]}</span>`;
        }
        return priceStr;
      }
    },

    // 获取商品分类
    async getCommondityLabel() {
      this.loading = true;
      try {
        const res = await getCommondityLabel();
        // 筛选五个分类：id=21545efbac6545f89ac8ccf39f25b2ed（鞋袜）、216aeab8f3d14325b1b80f6cfe31b46e（美妆&护肤）、e15491058139436d87c2e71ff04a30a1（电子&数码产品）、e97d25cf40f94f059f017d82310bbd60（珠宝配饰）、f23677a3e21742ba8ef11c3b1ea761ab（服饰穿搭）
        let filterArr = res.filter(
          (v) =>
            v.id == "21545efbac6545f89ac8ccf39f25b2ed" ||
            v.id == "216aeab8f3d14325b1b80f6cfe31b46e" ||
            v.id == "e15491058139436d87c2e71ff04a30a1" ||
            v.id == "e97d25cf40f94f059f017d82310bbd60" ||
            v.id == "f23677a3e21742ba8ef11c3b1ea761ab"
        );

        // 不同国家选择多语言
        let MultilingualArr = this.handleMultilingualName(
          "other",
          filterArr,
          "labelname",
          "labelcont"
        );
        this.commodityList = MultilingualArr;
      } catch (error) {
        console.error("获取商品分类失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 获取商品列表
    async initData() {
      let { params } = this;
      try {
        const res = await getCommonditySpecial(params);
        // 假设 res 是一个包含商品列表的数组
        if (res.list && res.list.length > 0) {
          // 不同国家选择多语言
          let MultilingualArr = this.handleMultilingualName(
            "shop",
            res.list,
            "commodityname"
          );

          // 将 MultilingualArr 处理成二维数组，每组包含 5 条数据
          const chunkSize = 5;
          const twoDimensionalArray = [];
          for (let i = 0; i < MultilingualArr.length; i += chunkSize) {
            twoDimensionalArray.push(MultilingualArr.slice(i, i + chunkSize));
          }
          this.dataList = twoDimensionalArray;
          this.listTotal = res.total;
          console.log(this.dataList, "===---2");
        }
      } catch (error) {
        console.error("获取商品列表失败:", error);
      }
    },

    // 原有的方法
    handleScroll() {
      const colmunThree = document.querySelector(".commodity_container");
      if (colmunThree) {
        const rect = colmunThree.getBoundingClientRect();
        // 如果元素已固定，且顶部距离大于 30px，取消固定
        if (this.isTopReached && rect.top > 30) {
          this.isTopReached = false;

          this.orderTipExpanded = false;
          this.shopCategoryExpanded = false;
          this.shouldAddOrderTipClass = false;
          this.shouldAddShopCategoryClass = false;
        }
        // 如果元素未固定，且顶部距离小于等于 0，固定元素
        else if (!this.isTopReached && rect.top <= 60) {
          this.isTopReached = true;
        }
      }
    },

    // 切换订单提示展开状态
    toggleOrderTip() {
      this.orderTipExpanded = !this.orderTipExpanded;
      this.shouldAddOrderTipClass = !this.shouldAddOrderTipClass;
    },
    // 切换商品分类展开状态
    toggleShopCategory() {
      this.shopCategoryExpanded = !this.shopCategoryExpanded;
      this.shouldAddShopCategoryClass = !this.shouldAddShopCategoryClass;
      // 当展开时调用 swiper 的 update 方法
      if (this.shopCategoryExpanded) {
        this.swiperVisible = false; // 隐藏 Swiper 容器
        // 假设这里有异步加载内容的逻辑
        this.loadSwiperContent().then(() => {
          this.$nextTick(() => {
            if (this.$refs.mySwiperFixed && this.$refs.mySwiperFixed.swiper) {
              this.$refs.mySwiperFixed.swiper.update();
              console.log("Swiper updated"); // 添加调试信息
              this.swiperVisible = true; // 显示 Swiper 容器
            }
          });
        });
      }
    },

    async loadSwiperContent() {
      // 模拟异步加载内容
      return new Promise((resolve) => {
        setTimeout(() => {
          // 这里可以添加实际的异步加载逻辑
          resolve();
        }, 500);
      });
    },

    handleGoHome() {},

    handleCurrentChange(e) {
      this.params.Page = e;
      // this.dataList = [];
      this.initData();
    },

    // 获取商品关键字标签
    getShopKeywordLabel() {
      getShopKeywordLabel().then((res) => {
        let filterData = res.filter((v) => v.labelstate == 1);
        // 推荐的数据isintro=1
        let recomData = filterData
          .filter((v) => v.isintro == 1)
          .sort((a, b) => b.sort - a.sort);
        // sort排序
        let generalData = filterData
          .filter((v) => v.isintro == 0)
          .sort((a, b) => b.sort - a.sort);

        let dataArr = [...recomData, ...generalData];

        // 不同国家选择多语言
        let MultilingualArr = this.handleMultilingualName(
          'other',
          dataArr,
          "typename",
        );

        this.popupLabelList = MultilingualArr;
        this.labelList = dataArr;
      });
    },

    // 获取品牌
    getSpecialQyList() {
      getSpecialQyList({ countryid: this.params.countryid }).then((res) => {
        // 读取特定的企业
        // 圭品-174  7度-190  VESCOR-201  花匣子-161   安琦悦-196   卓古艺-199   熙雨韩-193  流洋-198   Oi.Ms Nail-202
        // 圭品、7度、VESCOR、花匣子、安琦悦、卓古艺、渣哥、熙雨韩、流洋、融合供应链、Oi.Ms Nail
        let filterArr = res.list.filter(
          (v) =>
            v.id == 174 ||
            v.id == 190 ||
            v.id == 201 ||
            v.id == 161 ||
            v.id == 196 ||
            v.id == 199 ||
            v.id == 193 ||
            v.id == 198 ||
            v.id == 202 ||
            v.id == 207
        );
        this.qyList = filterArr;
      });
    },

    // 重置数据
    handleRest() {
      this.params.Page = 1;
      this.params.brandid = "";
      this.params.qyid = "";
      this.qyStr = "";
      this.params.ordertype = "";
      this.params.keyword = "";
      this.params.labelid = "";
      this.params.labelid2 = "";
      this.params.labelid3 = "";
      this.label2Str = "";
      this.label3Str = "";
      this.params.labels = "";
      this.labelList.forEach((v) => {
        v.active = false;
      });
      this.initData();
    },
    // 价格排序
    handleOrderType(type) {
      this.params.Page = 1;
      this.params.ordertype = type;
      this.initData();
    },
    // 修改品牌
    changeBrand(e) {
      this.params.brandid = e;
      this.initData();
    },
    // 选择企业
    handleQyItem(item) {
      this.params.qyid = item.id;
      this.qyStr = item.qyename ? item.qyename : item.qyname;
      this.initData();
      this.isShow = false;
    },
    // 标签选择
    handleLabelItem(id, type, item) {
      if (id == "") {
        this.params.labelid = "";
        this.params.labelid2 = "";
        this.params.labelid3 = "";
        this.label1Str = "";
        this.label2Str = "";
        this.label3Str = "";
        this.label2Arr = [];
        this.label3Arr = [];
        this.initData();
        this.isLabelShow = false;
        return;
      }
      let { label1Arr, label2Arr } = this;
      if (type == "label1") {
        this.params.labelid = id;
        this.params.labelid2 = "";
        this.params.labelid3 = "";
        this.label2Str = "";
        this.label3Str = "";
        this.label1Str = item.multilingualName;
        this.label2Arr = [];
        this.label3Arr = [];
        let filterArr = label1Arr.filter((v) => v.id == id)[0];
        if (filterArr.childs2.length > 0) {
          // 不同国家选择多语言
          let MultilingualArr = this.handleMultilingualName(
            filterArr.childs2,
            "labelname",
            "labelname_e",
            "labelname_m",
            "labelname_y"
          );

          this.label2Arr = MultilingualArr.filter(
            (v) => v.labelstate == 1
          ).sort((a, b) => a.sort - b.sort);
        } else {
          this.initData();
          this.isLabelShow = false;
        }
      } else if (type == "label2") {
        this.params.labelid2 = id;
        this.params.labelid3 = "";
        this.label3Str = "";
        this.label2Str = item.multilingualName;
        this.label3Arr = [];

        let filterArr = label2Arr.filter((v) => v.id == id)[0];
        if (filterArr.childs3.length > 0) {
          // 不同国家选择多语言
          let MultilingualArr = this.handleMultilingualName(
            filterArr.childs3,
            "labelname",
            "labelname_e",
            "labelname_m",
            "labelname_y"
          );
          this.label3Arr = MultilingualArr.filter(
            (v) => v.labelstate == 1
          ).sort((a, b) => a.sort - b.sort);
        } else {
          this.initData();
          this.isLabelShow = false;
        }
        //
      } else if (type == "label3") {
        this.params.labelid3 = id;
        this.label3Str = item.multilingualName;
        this.initData();
        this.isLabelShow = false;
      }
    },
    // 选择关键字标签
    handleLabel(item) {
      const index = this.labelList.findIndex((v) => v.typeid === item.typeid);
      if (index !== -1) {
        this.labelList[index].active = !this.labelList[index].active;
        // 确保 Vue 能检测到变化
        this.labelList.splice(index, 1, { ...this.labelList[index] });
      }
      this.updateLabels(); // 更新 labels
    },
    updateLabels() {
      this.params.labels = this.labelList
        .filter((item) => item.active) // 筛选出 active 为 true 的对象
        .map((item) => item.typeid) // 提取 typeid
        .join(","); // 用逗号连接成字符串
      this.initData();
    },
    // 显示关键字标签弹窗
    handleShowKeywordLabel() {
      this.popupLabelList = this.labelList;
      this.isKeywordLabelShow = true;
    },
    // 弹窗操作关键字标签
    handleKeywordLabelItem(item) {
      const index = this.popupLabelList.findIndex(
        (v) => v.typeid === item.typeid
      );
      if (index !== -1) {
        this.popupLabelList[index].active = !this.popupLabelList[index].active;
        // 确保 Vue 能检测到变化
        this.popupLabelList.splice(index, 1, { ...this.popupLabelList[index] });
      }
    },
    // 关键字弹窗选项确认
    handleQueryKeyword() {
      this.labelList = this.popupLabelList;
      this.params.labels = this.labelList
        .filter((item) => item.active) // 筛选出 active 为 true 的对象
        .map((item) => item.typeid) // 提取 typeid
        .join(","); // 用逗号连接成字符串
      this.isKeywordLabelShow = false;
      this.initData();
    },

    handleSearch() {
      this.params.Page = 1;
      this.initData();
    },

    isValidJsonString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (error) {
        return false;
      }
    },

    // 获取订单
    getOrderListWeb() {
      let params = {
        openid: this.OPENID,
        ordertype: "", // 订单类型
        keyword: "",
        qyid: "",
        returntalk: "", // 退款状态
        ischeck: "", // 订单审核
        paystate: 0, // 支付状态 =0=未支付 1=已支付
        orderstate: "未支付", // 订单状态 =未支付 待发货 已发货 已签收 已申请退费 已退费 已完成
        pageindex: 1,
        pagesize: 15,
        currency_trans: this.COUNTRY.id,
      };
      getOrderListWeb(params).then((res) => {
        this.isOrder = res.total > 0 ? true : false;

        this.getSpecialUserInfo();
      });
    },

    // 用户完善信息提示
    async getSpecialUserInfo() {
      // 获取仓库物流信息
      let dataForm = {
        pageindex: 1,
        pagesize: 1,
        keyword: "",
        isuse: "", // 是否启用 =1=启用 0=停用
        openid: this.OPENID,
        whtype: "", // 仓库服务类型 =私有仓 公共服务仓
        managetype: "", // 管理属性 =工厂 第三方服务机构 标准仓库
        countryids: this.COUNTRY.countryid, // 所在国家
        runstate: "", // 业务状态管理 =1=开启入库&代发业务 2=关闭入库&代发业务
        replacetype: "", // 代发业务模式管理 =1=一件代发（to 零售） 2=大货代发（to 集运） 3=退换货处理（to 零售）
        fee_cny: "", // 出入库服务收费币种
      };
      let res1 = await getSpecialUserResourceList(dataForm);
      if (res1.total > 0) {
        this.isWarehouse = true;
      }

      // 获取物流记录
      let logisticsForm = {
        pageindex: 1,
        pagesize: 15,
        keyword: "",
        openid: this.OPENID,
        countryids: this.COUNTRY.countryid,
      };
      let res2 = await getLogisticsAddressList(logisticsForm);
      if (res2.total > 0) {
        this.isLogistics = true;
      }

      if (this.USERINFO.limittype != 3) {
        if (res1.total > 0 && res2.total > 0) {
          this.isUserInfoShow = false;
        } else {
          this.isUserInfoShow = true;
        }
      }
    },

    handleGo(id, qyid, name, item) {
      let { isLogistics, isWarehouse } = this;
      if (name == "cRetailAddOrder" && (!isLogistics || !isWarehouse)) {
        this.isUserInfoShow = true;
        return;
      }

      if (name == "cRetailAddOrder" && !item.multilingualPrice) {
        this.triggerOrder = {
          click: true,
          qyid,
          id,
          name,
        };
        this.setShopMultiPrice(item);
      } else {
        this.$store.commit("setDataPage", this.params.Page);
        this.encryptstringadd(name, { id, qyid });
      }
    },

    // 创建订单的时候，需要先更新价格
    handleAddOrder(id, qyid, name, item) {
      this.triggerOrder = {
        click: true,
        qyid,
        id,
        name,
      };
      this.setShopMultiPrice(item);
    },

    handleGo2(name) {
      this.$router.push({
        name,
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleGoManageCenter(name) {
      this.$router.push({ name });
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning(this.$t("Currently unavailable"));
    },

    handleCopyBtnPrice() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    handleCountry(item) {
      this.$store.dispatch("updateCountry", item);
      window.location.reload(); // 重新加载当前页面
    },

    // 新增多币种价格
    addShopMultiPrice() {
      addShopMultiPrice(this.multilingualPrice).then((data) => {
        if (data.result) {
          this.initData();
        } else {
          this.$message.warning(data.message);
        }
      });
    },
    // 修改多币种价格
    editShopMultiPrice() {
      editShopMultiPrice(this.multilingualPrice).then((data) => {
        if (data.result) {
          this.initData();
        } else {
          this.$message.warning(data.message);
        }
      });
    },
    // 设置多币种价格
    setShopMultiPrice(item) {
      let { countryExrateObj } = this.USERINFO;
      let newMultilingualPrice = {
        id: item.ams_shop_commodity_exrate.id
          ? item.ams_shop_commodity_exrate.id
          : "",
        cmid: item.id,
      };
      if (countryExrateObj.countryid == 4) {
        // 越南
        newMultilingualPrice.yue_price_base = this.convertCurrency(
          item.cbprice
        );
        newMultilingualPrice.yue_price = this.convertCurrency(item.price);
        newMultilingualPrice.yue_tuan = this.convertCurrency(item.groupprice);
        newMultilingualPrice.yue_tuan_base = this.convertCurrency(item.pfprice);
      } else if (countryExrateObj.countryid == 8) {
        // 美国
        newMultilingualPrice.ame_price_base = this.convertCurrency(
          item.cbprice
        );
        newMultilingualPrice.ame_price = this.convertCurrency(item.price);
        newMultilingualPrice.ame_tuan = this.convertCurrency(item.groupprice);
        newMultilingualPrice.ame_tuan_base = this.convertCurrency(item.pfprice);
      } else if (countryExrateObj.countryid == 3) {
        // 日本
        newMultilingualPrice.jap_price_base = this.convertCurrency(
          item.cbprice
        );
        newMultilingualPrice.jap_price = this.convertCurrency(item.price);
        newMultilingualPrice.jap_tuan = this.convertCurrency(item.groupprice);
        newMultilingualPrice.jap_tuan_base = this.convertCurrency(item.pfprice);
      } else if (countryExrateObj.countryid == 5) {
        // 泰国
        newMultilingualPrice.tai_price_base = this.convertCurrency(
          item.cbprice
        );
        newMultilingualPrice.tai_price = this.convertCurrency(item.price);
        newMultilingualPrice.tai_tuan = this.convertCurrency(item.groupprice);
        newMultilingualPrice.tai_tuan_base = this.convertCurrency(item.pfprice);
      } else if (countryExrateObj.countryid == 2) {
        // 俄罗斯
        newMultilingualPrice.lu_price_base = this.convertCurrency(item.cbprice);
        newMultilingualPrice.lu_price = this.convertCurrency(item.price);
        newMultilingualPrice.lu_tuan = this.convertCurrency(item.groupprice);
        newMultilingualPrice.lu_tuan_base = this.convertCurrency(item.pfprice);
      } else if (countryExrateObj.countryid == 6) {
        // 加拿大
        newMultilingualPrice.jia_price_base = this.convertCurrency(
          item.cbprice
        );
        newMultilingualPrice.jia_price = this.convertCurrency(item.price);
        newMultilingualPrice.jia_tuan = this.convertCurrency(item.groupprice);
        newMultilingualPrice.jia_tuan_base = this.convertCurrency(item.pfprice);
      }

      this.multilingualPrice = newMultilingualPrice;

      if (newMultilingualPrice.id) {
        this.editShopMultiPrice();
      } else {
        this.addShopMultiPrice();
      }
    },

    // 计算汇率转换后的值
    convertCurrency(inputValue) {
      let { countryExrateObj } = this.USERINFO;
      if (
        countryExrateObj.Currency == "韩元" ||
        countryExrateObj.Currency == "越南盾" ||
        countryExrateObj.Currency == "泰铢" ||
        countryExrateObj.Currency == "日元" ||
        countryExrateObj.Currency == "卢布"
      ) {
        return calculator(inputValue)
          .multiply(countryExrateObj.rate)
          .toNumber()
          .toFixed();
      } else {
        let num = calculator(inputValue)
          .multiply(countryExrateObj.rate)
          .toNumber();
        if (Number.isInteger(num)) {
          return num; // 如果是整数，直接返回
        } else {
          return num.toFixed(1); // 如果是小数，保留一位小数
        }
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.home_container {
  padding-top: 60px;
  box-sizing: border-box;
  background: #e7e8f0;
  .head_container {
    height: 340px;
    background: #fff;
    margin-bottom: 30px;
    padding: 20px 0 0;
    box-sizing: border-box;
    opacity: 1; /* 默认不透明 */
    top: 0; /* 默认位置 */
    transition: opacity 0.3s ease, top 0.3s ease; /* 只对 opacity 和 top 过渡 */
    &.top-reached {
      background: #fff;
      position: fixed;
      left: 0;
      top: 60px;
      right: 0;
      z-index: 999;
      height: 160px;
    }
    .order_tip {
      width: 1360px;
      height: 50px;
      border-radius: 15px;
      box-shadow: -10px 0px 6px 0px rgba(214, 214, 214, 0.5),
        10px 0px 6px 0px rgba(214, 214, 214, 0.5);
      border: 3px solid #eeeff3;
      padding: 0 24px;
      box-sizing: border-box;
      margin: 0 auto 17px;
      .icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      p {
        font-size: 16px;
        color: #333333;
        span {
          color: #ff0000;
          cursor: pointer;
        }
      }
    }
    .search_container {
      width: 1360px;
      margin: auto;
      .sraech_sort {
        font-size: 16px;
        color: #333333;
        padding-left: 24px;
        box-sizing: border-box;
        .rest_box {
          cursor: pointer;
          span {
            width: 25px;
            height: 21px;
            background: url("../assets/images/refresh_icon.png") no-repeat
              center;
            background-size: cover;
            margin-left: 9px;
          }
        }
        .ordertype_box {
          margin-left: 34px;
          cursor: pointer;
          .shangzhang_icon {
            width: 25px;
            height: 20px;
            background: url("../assets/images/shangzhang_icon.png") no-repeat
              center;
            background-size: cover;
            margin: 0 9px 0 10px;
          }
          .xiajiang_icon {
            width: 25px;
            height: 20px;
            background: url("../assets/images/xiazhang_icon.png") no-repeat
              center;
            background-size: cover;
          }
        }
      }
      .search {
        .txt {
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          padding: 0 8px 0 23px;
          box-sizing: border-box;
        }
        .search_input_box {
          width: 500px;
          height: 50px;
          background: #f0f0f0;
          border-radius: 25px;
          position: relative;
          /deep/ .el-input {
            padding: 0;
            height: 100%;
          }
          /deep/ .el-input__inner {
            height: 100%;
            background: none;
            border: none;
          }
          span {
            position: absolute;
            cursor: pointer;
            right: 20px;
            background: url("../assets/images/search_btn.png") no-repeat center;
            background-size: cover;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .shop_category_wrap {
      width: 1360px;
      margin: auto;
      padding: 0 19px;
      box-sizing: border-box;
      height: 123px;
      position: relative;
      .shop_category_main {
        height: 123px;
        cursor: pointer;
      }
    }
    .label_container {
      height: 80px;
      border-top: 1px solid #e7e8f0;
      padding: 0 310px;
      .icon {
        width: 16px;
        height: 17px;
        margin-right: 10px;
        background: url("../assets/images/label_icon.png") no-repeat center;
        background-size: cover;
        flex-shrink: 0;
      }
      .label_wrap {
        flex: 1;
        // 单行文本隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .label_item {
          font-size: 16px;
          color: #026DD1;
          margin-right: 15px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .commodity_container {
    padding-bottom: 180px;
    .more {
      span {
        cursor: pointer;
        background-size: cover;
        width: 110px;
        height: 30px;
        background: #000000;
        border-radius: 45px;
        font-size: 12px;
        color: #fff;
        padding: 0 14px;
        box-sizing: border-box;
        .iconfont {
          font-size: 10px;
          transform: rotate(-90deg);
        }
      }
    }
    .commodity_wrap {
      height: 610px;
      padding: 30px;
      box-sizing: border-box;
      .commodity_list {
        .commodity_list_item {
          margin-left: 36px;
          &:first-child {
            margin-left: 0;
          }
          .thumb {
            height: 290px;
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  // 商品分类样式
  .shop_category_wrap {
    .shop_category_main {
      .thumb {
        width: 65px;
        height: 65px;
        margin-right: 10px;
        flex-shrink: 0;
      }
      .content {
        color: #333333;
        h1 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 3px;
        }
        p {
          font-size: 14px;
        }
      }
    }
    /deep/ .swiper-button-prev {
      left: -35px;
      background-image: none;
      .iconfont {
        transform: rotate(180deg);
        font-size: 34px;
        display: inline-block;
      }
    }
    /deep/ .swiper-button-next {
      right: -35px;
      background-image: none;
      .iconfont {
        font-size: 34px;
        display: inline-block;
      }
    }
  }

  /* 左侧固定内容样式 */
  .left-fixed {
    position: fixed;
    left: -200px; /* 默认隐藏在左侧 */
    top: 273px;
    width: 190px;
    z-index: 999;
    transition: left 0.3s ease; /* 添加过渡效果 */
    /* 滑动时显示左侧固定内容 */
    &.slide-in {
      left: 0; /* 从左到右滑出 */
    }

    /* 商品分类框样式 */
    .shop-category-wrap {
      width: 160px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5),
        -36px 0px 0px 0px #dcdcdc;
      border-radius: 0px 30px 30px 0px;
      margin-bottom: 20px;
      position: relative;
      transition: width 0.3s ease; /* 添加宽度过渡效果 */
      &::after {
        position: absolute;
        content: "";
        width: 60px;
        height: 130px;
        background: #dcdcdc;
        border-radius: 0px 30px 30px 0px;
        top: 0;
        right: -40px;
        z-index: -1;
      }

      /* 新增的订单提示框样式 */
      &.new-shop-category-style {
        width: 1350px;
        height: 130px;
        background: #ffffff;
        border-radius: 0px 30px 30px 0px;
        &::after {
          position: absolute;
          content: "";
          width: 60px;
          height: 130px;
          background: #000000;
          border-radius: 0px 30px 30px 0px;
          top: 0;
          right: -40px;
          z-index: -1;
        }
      }

      /* 商品分类框内容样式 */
      .shop-category-content {
        height: 130px;

        .shop-category-content-show {
          height: 100%;
          padding: 0 59px;
          box-sizing: border-box;
          position: relative;
          .shop_category_wrap {
            width: 100%;
            height: 100%;
          }
          /* 确保展开状态下 swiper 容器有正确的宽度 */
          .swiper-container {
            width: 100%; /* 或者根据实际需求设置宽度 */
            height: 100%;
          }
          .shop_category_main {
            height: 130px;
          }
          /deep/ .swiper-button-prev {
            left: 24px;
          }
          /deep/ .swiper-button-next {
            right: 24px;
          }
        }
        .shop-category-content-hide {
          height: 100%;
          .icon {
            background: url("../assets/images/commodity_cate.png") no-repeat
              center;
            background-size: cover;
            width: 105px;
            height: 65px;
          }
        }
      }
    }

    /* 订单提示框样式 */
    .order-tip-wrap {
      width: 90px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5),
        -36px 0px 0px 0px #dcdcdc;
      border-radius: 0px 30px 30px 0px;
      position: relative;
      transition: width 0.3s ease; /* 添加宽度过渡效果 */
      &::after {
        position: absolute;
        content: "";
        width: 60px;
        height: 130px;
        background: #dcdcdc;
        border-radius: 0px 30px 30px 0px;
        top: 0;
        right: -40px;
        z-index: -1;
      }

      /* 新增的订单提示框样式 */
      &.new-order-tip-style {
        width: 280px;
        height: 130px;
        background: #ffffff;
        border-radius: 0px 30px 30px 0px;
        &::after {
          position: absolute;
          content: "";
          width: 60px;
          height: 130px;
          background: #000000;
          border-radius: 0px 30px 30px 0px;
          top: 0;
          right: -40px;
          z-index: -1;
        }
      }

      /* 订单提示框内容样式 */
      .order-tip-content {
        height: 130px;
        .order-tip-content-show {
          height: 100%;
          padding-left: 65px;
          box-sizing: border-box;
          align-items: flex-start;
          .txt {
            width: 143px;
            height: 33px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            line-height: 17px;
            white-space: nowrap;
          }
          .more {
            width: 125px;
            height: 17px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #ff0000;
            line-height: 29px;
            white-space: nowrap;
            margin-top: 15px;
            cursor: pointer;
          }
        }
        .order-tip-content-hide {
          height: 100%;
          position: relative;
          .icon {
            background: url("../assets/images/message_icon_fixed.png") no-repeat
              center;
            background-size: cover;
            width: 50px;
            height: 50px;
          }
          span {
            width: 10px;
            height: 10px;
            background: #ff0000;
            border-radius: 50%;
            position: absolute;
            top: 47px;
          }
        }

        // .order-tip-content-show,
        // .order-tip-content-hide {
        //   height: 130px;
        //   opacity: 0;
        //   // max-height: 0;
        //   overflow: hidden;
        //   transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;
        // }
        // .order-tip-content-show.is-expanded,
        // .order-tip-content-hide.is-expanded {
        //   opacity: 1;
        //   // max-height: 130px; /* 根据实际内容调整最大高度 */
        // }
      }
    }

    .toggle-btn {
      position: absolute;
      width: 40px;
      height: 130px;
      cursor: pointer;
      right: -40px;
      top: 0;
      span {
        display: inline-block;
        width: 7px;
        height: 13px;
        background: url("../assets/images/toggle_zhan.png") no-repeat center;
      }
      &.new-toggle-btn {
        span {
          background: url("../assets/images/toggle_shou.png") no-repeat center;
        }
      }
    }
  }
}
</style>